import { useState, useEffect } from 'react';
function getStorageValue(key, defaultValue) {
    const savedValue = localStorage.getItem(key);
    try {
        const initial = JSON.parse(savedValue);
        return initial !== null && initial !== void 0 ? initial : defaultValue;
    }
    catch (_a) {
        return defaultValue;
    }
}
export function useLocalStorage(key, defaultValue) {
    if (!key) {
        throw new Error('key is required');
    }
    // value must be an object that can be serialized to JSON.
    const [value, setValue] = useState(() => {
        const value = getStorageValue(key, defaultValue);
        return value;
    });
    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);
    return [value, setValue];
}
